module.exports = "/images/coming-soon.jpg?0dbf528de351f47dcf62cdea121fdb44";